"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const request_1 = require("../requests/request");
const models_1 = require("../models");
class API {
    /**
     * Fetches the newsfeed
     * @returns {Promise<NewsFeedItem[]>} The Promise contains an APIError if rejected
     */
    static getNewsFeed(search, paging) {
        let apiRequest = new request_1.AuthenticatedRequest('/newsfeed', request_1.HTTPMethod.GET, request_1.APIVersion.v1_2, {
            limit: paging.limit,
            skip: paging.skip,
            term: search
        });
        return apiRequest.send(models_1.NewsFeedItem).then((response) => {
            return response.data;
        });
    }
    /**
     * Fetches the newsfeed for the followed providers
     * @returns {Promise<NewsFeedItem[]>} The Promise contains an APIError if rejected
     */
    static getFollowingNewsFeed(search, paging) {
        let apiRequest = new request_1.AuthenticatedRequest('/newsfeed/following', request_1.HTTPMethod.GET, request_1.APIVersion.v1_2, {
            limit: paging.limit,
            skip: paging.skip,
            term: search
        });
        return apiRequest.send(models_1.NewsFeedItem).then((response) => {
            return response.data;
        });
    }
    /**
     * Fetches the available news providers
     * @returns {Promise<NewsProvider[]>} The Promise contains an APIError if rejected
     */
    static getNewsProviders(paging) {
        let apiRequest = new request_1.AuthenticatedRequest('/news/providers', request_1.HTTPMethod.GET, request_1.APIVersion.v1_2);
        return apiRequest.send(models_1.NewsProvider).then((response) => {
            return response.data;
        });
    }
    /**
     * Fetches the available news providers
     * @returns {Promise<NewsProvider[]>} The Promise contains an APIError if rejected
     */
    static getNewsForProvider(provider_id, search, paging) {
        let apiRequest = new request_1.AuthenticatedRequest('/news/providers/' + provider_id + '/newsfeed', request_1.HTTPMethod.GET, request_1.APIVersion.v1_2, {
            limit: paging.limit,
            skip: paging.skip,
            term: search
        });
        return apiRequest.send(models_1.NewsFeedItem).then((response) => {
            return response.data;
        });
    }
    /**
    * Fetches the news
    * @returns {Promise<NewsProvider[]>} The Promise contains an APIError if rejected
    */
    static getNewsForProviderSlug(provider_id, slug) {
        let apiRequest = new request_1.AuthenticatedRequest('/news/providers/' + provider_id + '/' + encodeURIComponent(slug), request_1.HTTPMethod.GET, request_1.APIVersion.v1_2);
        return apiRequest.send(models_1.NewsFeedItem).then((response) => {
            return response.data;
        });
    }
    /**
     * Follows the provider with the given id
     * @returns {Promise<NewsProvider>} The Promise contains an APIError if rejected
     */
    static followProvider(provider_id) {
        let apiRequest = new request_1.AuthenticatedRequest('/news/providers/' + provider_id + '/follow', request_1.HTTPMethod.POST, request_1.APIVersion.v1_2);
        return apiRequest.send(models_1.NewsProvider).then((response) => {
            return response.data;
        });
    }
    /**
     * Follows the provider with the given id
     * @returns {Promise<NewsProvider>} The Promise contains an APIError if rejected
     */
    static unfollowProvider(provider_id) {
        let apiRequest = new request_1.AuthenticatedRequest('/news/providers/' + provider_id + '/unfollow', request_1.HTTPMethod.POST, request_1.APIVersion.v1_2);
        return apiRequest.send(models_1.NewsProvider).then((response) => {
            return response.data;
        });
    }
}
exports.API = API;



//////////////////
// WEBPACK FOOTER
// ./node_modules/bpm-client-api/lib/endpoints/news.js
// module id = 963
// module chunks = 0